import { useMediaQuery } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { LicenseInfo } from '@mui/x-license';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import { BrowserRouter } from 'react-router';

import { PageLayout } from './components/shared/PageLayout/PageLayout';
import ApolloContextProvider from './providers/ApolloContext/ApolloContextProvider';
import { AppInsightsProvider } from './providers/AppInsightsProvider/AppInsightsProvider';
import MsalContextProvider from './providers/MsalContext/MsalContextProvider';
import { NotificationProvider } from './providers/NotificationProvider/NotificationProvider';
import PageRoutes from './routes/PageRoutes';
import { appLightTheme, appDarkTheme } from './theme/theme';

dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(localizedFormat);

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);

function App() {
  const darkThemeMq = useMediaQuery('(prefers-color-scheme: dark)');
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <BrowserRouter>
        <MsalContextProvider>
          <AppInsightsProvider>
            <ApolloContextProvider>
              <ThemeProvider theme={darkThemeMq ? appDarkTheme : appLightTheme}>
                <CssBaseline />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <NotificationProvider
                    defaultPosition={{ vertical: 'bottom', horizontal: 'left' }}
                    defaultDuration={3000}
                  >
                    <PageLayout>
                      <PageRoutes />
                    </PageLayout>
                  </NotificationProvider>
                </LocalizationProvider>
              </ThemeProvider>
            </ApolloContextProvider>
          </AppInsightsProvider>
        </MsalContextProvider>
      </BrowserRouter>
    </LocalizationProvider>
  );
}

export default App;
